<div class="head"></div>
<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="70" style="padding: 5px">
    <mat-card>
      <mat-card-title
        >Comencemos publicando algunas observaciones</mat-card-title
      >
      <mat-card-subtitle
        >¿Necesitas inspiración? Aquí hay algunas variedades que se observan
        cerca...
      </mat-card-subtitle>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        style="margin: 10px"
      >
        <div style="background-color: #000; width: 155px">
          <img
            src="https://wikipapa.org/photos/ptpe_2016jun_allawachuco_tuber.jpg"
            style="
              height: 120px;
              width: 100%;
              object-fit: fill;
              margin-bottom: -6px;
            "
          />
        </div>
        <div style="background-color: #000; width: 155px">
          <img
            src="https://wikipapa.org/photos/ptpe_2016jun_allqa-papa_tuber.jpg"
            style="
              height: 120px;
              width: 100%;
              object-fit: fill;
              margin-bottom: -6px;
            "
          />
        </div>

        <div style="background-color: #000; width: 155px">
          <img
            src="https://wikipapa.org/photos/ptpe_2016jun_amaya_tuber.jpg"
            style="
              height: 120px;
              width: 100%;
              object-fit: fill;
              margin-bottom: -6px;
            "
          />
        </div>

        <div style="background-color: #000; width: 155px">
          <img
            src="https://wikipapa.org/photos/ptpe_2021hvca_amarilla_tuberculo.jpg"
            style="
              height: 120px;
              width: 100%;
              object-fit: fill;
              margin-bottom: -6px;
            "
          />
        </div>
      </div>
      <mat-card-content>
        <p>
          Sal a las parcelas y observa una variedad individual. Escoge una y
          toma una foto clara y completa. Si ya tienes una foto de una variedad,
          añádela ahora. También puedes utilizar las aplicaciones móviles
          VarScout para compartir tu observación con la comunidad.
        </p>

        <p>
          Una vez que haya compartido sus observaciones, esta página le mostrará
          actualizaciones de la comunidad en forma de comentarios e
          identificaciones. ¡Quién sabe lo que descubrirás!
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary" routerLink="/observaciones">
          Examinar observaciones
        </button>
        <button mat-stroked-button>Guia de inicio</button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div fxFlex="30" style="padding: 5px">
    <div class="example-button-row" style="display: grid">
      <button mat-flat-button color="primary" routerLink="/explorer-item-new/">
        <mat-icon>add</mat-icon> Agregar observaciones
      </button>
    </div>

    <h3>Mas</h3>

    <mat-card>
      <mat-card-title>Guia de incio</mat-card-title>
      <mat-card-subtitle
        >Vamos a explicar las principales caracteristicas de este sitio
      </mat-card-subtitle>
      <mat-card-actions>
        <button mat-stroked-button>Comienza</button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
<div fxLayout="row" style="margin-top: 10px">
  <div fxFlex="70" style="padding: 5px">
    <mat-card>
      <mat-card-title>Siga algunos observadores cercanos</mat-card-title>
      <mat-card-subtitle>
        Si visita estos perfiles y hace clic en el boton de seguimiento, se le
        informara cuando publiquen una nueva observación
      </mat-card-subtitle>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div style="padding: 5px">
          <mat-card class="example-card">
            <mat-card-header>
              <mat-icon
                mat-card-avatar
                style="font-size: 2.8em; color: #8b2f00; margin: auto"
              >
                account_circle
              </mat-icon>

              <button mat-button color="primary">
                <mat-icon> person_pin </mat-icon> Vilma H.</button
              ><br />
              <button mat-button color="primary">
                <mat-icon> visibility </mat-icon> 409
              </button>
            </mat-card-header>
          </mat-card>
        </div>

        <div style="padding: 5px">
          <mat-card class="example-card">
            <mat-card-header>
              <mat-icon
                mat-card-avatar
                style="font-size: 2.8em; color: #8b2f00; margin: auto"
              >
                account_circle
              </mat-icon>

              <button mat-button color="primary">
                <mat-icon> person_pin </mat-icon> Luis R.</button
              ><br />
              <button mat-button color="primary">
                <mat-icon> visibility </mat-icon> 79
              </button>
            </mat-card-header>
          </mat-card>
        </div>

        <div style="padding: 5px">
          <mat-card class="example-card">
            <mat-card-header>
              <mat-icon
                mat-card-avatar
                style="font-size: 2.8em; color: #8b2f00; margin: auto"
              >
                account_circle
              </mat-icon>

              <button mat-button color="primary">
                <mat-icon> person_pin </mat-icon> Ana V.</button
              ><br />
              <button mat-button color="primary">
                <mat-icon> visibility </mat-icon> 54
              </button>
            </mat-card-header>
          </mat-card>
        </div>

        <!-- <div style="padding: 5px">
          <mat-card class="example-card">
            <mat-card-header>
              <div mat-card-avatar class="example-header-image"></div>
              <mat-card-subtitle>
                <button mat-button color="primary">
                  <mat-icon> person_pin </mat-icon> Observer_1</button
                ><br />
                <button mat-button color="primary">
                  <mat-icon> visibility </mat-icon> Views_1
                </button>
              </mat-card-subtitle>
            </mat-card-header>
          </mat-card>
        </div> -->
      </div>
    </mat-card>
  </div>
</div>
